import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  routeHasExist
} from '@/libs/util'
import router from '@/router'
import {
  dynamicRouterAdd
} from '@/libs/router-util' // ①添 引入加载菜单
export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    // homeRoute: getHomeRoute(routers),
    local: '',
    menuList: []
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(dynamicRouterAdd(), rootState.user.access)
    // menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access)
    // menuList: (state, getters, rootState) => getMenuByRouter(state.menuList, rootState.user.access) // ①改 通过路由列表得到菜单列表
  },
  mutations: {

    updateMenuList (state, routes) { // ①添 接受前台数组，刷新菜单
      // console.log(state, routes, 'updateMenuList')
      router.addRoutes(routes) // 动态添加路由
      state.menuList = routes
    },
    setBreadCrumb (state, routeMetched) {
      state.breadCrumbList = getBreadCrumbList(routeMetched, state.homeRoute)
    },
    setTagNavList (state, list) {
      if (list) {
        state.tagNavList = [...list]
        setTagNavListInLocalstorage([...list])
      } else state.tagNavList = getTagNavListFromLocalstorage()
    },
    addTag (state, {
      route,
      type = 'unshift'
    }) {
      if (!routeHasExist(state.tagNavList, route)) {
        if (type === 'push') state.tagNavList.push(route)
        else {
          if (route.name === 'home') state.tagNavList.unshift(route)
          else state.tagNavList.splice(1, 0, route)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      state.local = lang
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js